import React from "react";

const Header = () => {
  return (
    <div className={"row"}>
      <p className={"page-header"}>💻IamNeoAI Talent Center</p>
    </div>
  );
};

export default Header;
